import { useNavigate } from 'react-router';
import { ContinueButton } from '../../../../components/ContinueButton/ContinueButton';
import { useUserData } from '../../../../providers/UserDataProvider/useUserData';
import styles from './FactBlock.module.scss';
import { Image } from '../../../../components/Image/Image';
import { ampScreenCompleted } from '../../../../utils/AmplitudeEvents';
export const FactBlock = ({ content, nextSlug })=>{
  const { userData } = useUserData();
  const navigate = useNavigate();
  const { title,slug,button, text, image } = content;
  const gender = userData?.gender === 'Female' ? 'Female' : 'Male';
  return (
    <>
    <div className={styles.wrapper}>
      {image && <Image className={styles.image} src={image}/>}
      {title && <div className={styles.title}>{title}</div>}
      {text && 
        <div className={styles.text}>
          {
            Array.isArray(text[gender]) && text[gender].map((html, i) => (
              <div key={i} dangerouslySetInnerHTML={{ __html: html }} />
            ))
          }
        </div>
      }
    </div>
    <ContinueButton
        onClick={() => {
          setTimeout(() => {
            ampScreenCompleted(slug,title || null)
            navigate(nextSlug);
          }, 500);
        }}
      >
        {button || null}
      </ContinueButton>
    </>
  );
}